// extracted by mini-css-extract-plugin
export default {"sectionContainer":"FiltersComponents_sectionContainer__Xbzjj","filterWrapper":"FiltersComponents_filterWrapper__L2dZV"};